import React from 'react';
import ReactDOM from 'react-dom';
import { SearchInput } from './SearchInput';
import { SearchHandler } from './SearchHandler';
import { SearchResultInfo } from './SearchResultInfo';
import { SearchResultTable } from './SearchResultTable';
import { Message } from 'oskari-ui';
import { LocaleProvider, ThemeProvider } from 'oskari-ui/util';
import styled from 'styled-components';
var Description = styled('div').withConfig({
  displayName: "DefaultSearchView__Description",
  componentId: "sc-1o2sfka-0"
})(["margin-bottom:8px;"]);
var SearchContainer = styled('div').withConfig({
  displayName: "DefaultSearchView__SearchContainer",
  componentId: "sc-1o2sfka-1"
})(["max-width:450px;"]);

/**
 * @class Oskari.mapframework.bundle.search.Flyout
 *
 * Renders the "search" flyout.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.search.DefaultView',
/**
 * @static @method create called automatically on construction
 *
 * @param {Oskari.mapframework.bundle.search.SearchBundleInstance}
 * Instance reference to component that created the tile
 *
 */
function (instance) {
  var _this = this;
  this.instance = instance;
  this.sandbox = this.instance.getSandbox();
  this.searchservice = instance.service;
  this.state = null;
  // Actions that get added to the search result popup
  this.resultActions = {};
  this._searchContainer = null;
  var instanceConf = instance.conf || {};
  this.handler = new SearchHandler(!!instanceConf.autocomplete, this.searchservice, this.sandbox, function () {
    _this.__refresh();
  });
  this.loc = Oskari.getMsg.bind(null, this.instance.getName());
}, {
  __refresh: function __refresh() {
    var _this2 = this;
    var el = this.getContainer();
    var _this$handler$getStat = this.handler.getState(),
      _this$handler$getStat2 = _this$handler$getStat.query,
      query = _this$handler$getStat2 === void 0 ? '' : _this$handler$getStat2,
      _this$handler$getStat3 = _this$handler$getStat.loading,
      loading = _this$handler$getStat3 === void 0 ? false : _this$handler$getStat3,
      _this$handler$getStat4 = _this$handler$getStat.suggestions,
      suggestions = _this$handler$getStat4 === void 0 ? [] : _this$handler$getStat4,
      _this$handler$getStat5 = _this$handler$getStat.result,
      result = _this$handler$getStat5 === void 0 ? {} : _this$handler$getStat5;
    var controller = this.handler.getController();
    var searchPerformed = result && Array.isArray(result.locations);
    ReactDOM.render(/*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: 'Search'
      }
    }, /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(SearchContainer, null, /*#__PURE__*/React.createElement(Message, {
      messageKey: "searchDescription",
      LabelComponent: Description
    }), /*#__PURE__*/React.createElement(SearchInput, {
      placeholder: this.instance.getLocalization('searchAssistance'),
      query: query,
      suggestions: suggestions,
      onSearch: controller.triggerSearch,
      onChange: controller.updateQuery,
      loading: loading
    }), searchPerformed && /*#__PURE__*/React.createElement(SearchResultInfo, {
      count: result.totalCount,
      hasMore: result.hasMore
    }), /*#__PURE__*/React.createElement(SearchResultTable, {
      result: result,
      onResultClick: function onResultClick(result) {
        return _this2._resultClicked(result);
      }
    })))), el[0]);
  },
  /**
   * @method createUi
   * Creates the UI for a fresh start
   */
  createUi: function createUi(container) {
    var ui = jQuery(container);
    ui.empty();
    // create ui
    var searchContainer = this.getContainer();
    // add it to container
    ui.append(searchContainer);
    this.__refresh();
  },
  getContainer: function getContainer() {
    if (!this._searchContainer) {
      var searchContainer = document.createElement('div');
      this._searchContainer = jQuery(searchContainer);
    }
    return this._searchContainer;
  },
  focus: function focus() {},
  _resultClicked: function _resultClicked(result) {
    var me = this;
    var popupId = 'searchResultPopup';
    var inst = this.instance;
    var sandbox = inst.sandbox;
    // Note! result.ZoomLevel is deprecated. ZoomScale should be used instead
    var moveReqBuilder = Oskari.requestBuilder('MapMoveRequest');
    var zoom = result.zoomLevel;
    if (result.zoomScale) {
      zoom = {
        scale: result.zoomScale
      };
    }
    sandbox.request(me.instance.getName(), moveReqBuilder(result.lon, result.lat, zoom));
    var loc = this.instance.getLocalization('resultBox');
    var resultActions = [];
    var resultAction;
    var action;
    for (var name in this.resultActions) {
      if (this.resultActions.hasOwnProperty(name)) {
        action = this.resultActions[name];
        resultAction = {};
        resultAction.name = name;
        resultAction.type = 'link';
        resultAction.action = action(result);
        resultAction.group = 1;
        resultActions.push(resultAction);
      }
    }
    var closeAction = {};
    closeAction.name = loc.close;
    closeAction.type = 'link';
    closeAction.group = 1;
    closeAction.action = function () {
      var rN = 'InfoBox.HideInfoBoxRequest';
      var rB = Oskari.requestBuilder(rN);
      var request = rB(popupId);
      sandbox.request(me.instance.getName(), request);
    };
    resultActions.push(closeAction);
    var alternatives = me._createAlternativeNamesHTMLBlock(result);
    var contentItem = {
      html: "<h3>".concat(Oskari.util.sanitize(result.name), "</h3>\n                        ").concat(alternatives, "\n                        <p>").concat(result.region, "<br/>\n                        ").concat(result.type, "</p>"),
      actions: resultActions
    };
    var content = [contentItem];
    var options = {
      hidePrevious: true
    };
    var rN = 'InfoBox.ShowInfoBoxRequest';
    var rB = Oskari.requestBuilder(rN);
    var request = rB(popupId, loc.title, content, {
      lon: result.lon,
      lat: result.lat
    }, options);
    sandbox.request(this.instance.getName(), request);
    if (Oskari.util.isMobile()) {
      this.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'close', 'Search']);
    }
  },
  _createAlternativeNamesHTMLBlock: function _createAlternativeNamesHTMLBlock(result) {
    if (!result || !result.localized) {
      return '';
    }
    var alternatives = result.localized.filter(function (cur) {
      return cur.name !== result.name;
    }).map(function (cur) {
      return "".concat(cur.name, " [").concat(cur.locale, "]");
    }).sort();
    if (alternatives.length === 0) {
      return '';
    }
    var loc = this.instance.getLocalization('resultBox');
    var div = document.createElement('div');
    div.style.fontSize = '12px';
    var list = document.createElement('ul');
    alternatives.forEach(function (txt) {
      var item = document.createElement('li');
      item.append(document.createTextNode(txt));
      list.append(item);
    });
    list.style.marginTop = '5px';
    list.style.listStylePosition = 'inside';
    div.append(document.createTextNode(loc.alternatives));
    div.append(list);
    return div.outerHTML;
  },
  addSearchResultAction: function addSearchResultAction(action) {
    this.resultActions[action.name] = action.callback;
  },
  removeSearchResultAction: function removeSearchResultAction(name) {
    delete this.resultActions[name];
  },
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  /**
   * @method setState
   * @param {Object} state
   */
  setState: function setState(state) {
    this.state = state;
  },
  /**
   * @method getState
   * @return {Object} state
   */
  getState: function getState() {
    if (!this.state) {
      return {};
    }
    return this.state;
  }
}, {
  /**
   * @static @property {String[]} protocol
   */
  protocol: ['Oskari.userinterface.Flyout']
});